import React from 'react';
import axios from 'axios';
import { Header, Segment, Button, Form, Table } from 'semantic-ui-react';
import { fetchFaculties } from '../../Lookups/util';
import { toast, ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class SPImplemenationsWithoutSPBasic extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            orgUnits: [],
            orgUnitId: null,
            data: [],

            sPBasic: null,
            sPBasics: [],
            setBasic: false,

        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getImplementations = this.getImplementations.bind(this);
        this.setSPBasic = this.setSPBasic.bind(this);
        this.getSPBasics = this.getSPBasics.bind(this);
    }

    componentDidMount() {
        axios.all([fetchFaculties()])
            .then(axios.spread((orgUnitsRes) => {
                this.setState({
                    orgUnits: orgUnitsRes.data.map(el => ({
                        key: el.id, value: el.id, text: el.name
                    }))
                });
            }))
            .catch(err => {
                console.log('Failed to fetch organizational units');
            });

        if (localStorage.getItem('orgUnitId')) {
            this.setState({ orgUnitId: localStorage.getItem('orgUnitId'), loaded: true });
            this.getImplementations(localStorage.getItem('orgUnitId'));
            this.getSPBasics(localStorage.getItem('orgUnitId'));
        }
    }

    setSPBasic(id, optLock) {
        let obj = { id, optLock, studyProgramBasic: { id: this.state.sPBasic } };
        axios.put('study-programs/set-basic', { ...obj })
            .then(res => {
                toast('Implementacija je spojena sa osnovnim studijskim programom.');
                this.setState({ setBasic: false, sPBasic: null });
                this.getImplementations(localStorage.getItem('orgUnitId'));
            })
            .catch(err => {
                toast('Došlo je do greške! Implementacija nije spojena sa osnovnim studijskim programom.');
                this.setState({ setBasic: false });
            });
    }

    handleInputChange(event, { name, value }) {
        if (name === 'sPBasic') {
            this.setState({ [name]: value });
            return;
        }

        this.setState({ [name]: value, setBasic: false });
        localStorage.setItem('orgUnitId', value);
        this.getImplementations(value);
        this.getSPBasics(value);
    }


    getImplementations(id) {
        let obj = { id };
        axios.post('study-programs/without-basic', { ...obj })
            .then(res => {
                this.setState({ data: res.data });
            })
            .catch(err => {
                console.log('failed to fetch implementations.');
            });
    }

    getSPBasics(id) {
        let obj = { archived: false };
        axios.post(`study-programs/basic/${id}`, { ...obj })
            .then(res => {
                this.setState({
                    sPBasics: res.data.map(e => ({
                        ...e, key: e.studyProgramBasic.id, value: e.studyProgramBasic.id, text: e.studyProgramBasic.name + ' (' + e.studyProgramBasic.studyCycles[0].displayName + ')'
                    }))
                });
            })
            .catch(err => {
                console.log('Failed to fetch study programs');
            });
    }


    render() {
        return (
            <div>
                <Header as="h1">Povezivanje implementacija smjera sa osnovnim studijskim programima</Header>
                <Segment.Group raised>
                    <Segment raised>
                        <Header as="h3">
                            Odabir organizacione jedinice
                        </Header>
                    </Segment>
                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Organizaciona jedinica</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite organizacionu jedinicu"
                                        value={localStorage.getItem('orgUnitId') ? parseInt(localStorage.getItem('orgUnitId'), 10) : this.state.orgUnitId}
                                        onChange={this.handleInputChange}
                                        name="orgUnitId"
                                        options={this.state.orgUnits}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Button color="blue" basic="true" label=" " onClick={() => this.setState({ loaded: true })}>Prikaži</Form.Button>
                            </Form.Group>
                        </Form>
                        <br/>
                    </Segment>
                    {this.state.loaded &&
                    <Segment>
                        {this.state.data.length ?
                            <Table celled selectable compact >
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>
                                            Odsjek
                                        </Table.HeaderCell>
                                        <Table.HeaderCell>
                                            Naziv implementacije
                                        </Table.HeaderCell>
                                        <Table.HeaderCell>
                                            Trajanje (godine / semestri)
                                        </Table.HeaderCell>
                                        <Table.HeaderCell>
                                            Titula
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan="2" />
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body> {this.state.data.map((el, index) =>
                                    (<Table.Row key={index}>
                                        <Table.Cell verticalAlign="middle">
                                            {el.departments.map(e => (<div>{e.name}<br /></div>))}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.studyProgram.name}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.studyProgram.durationYear} /  {el.studyProgram.durationSemester}
                                        </Table.Cell>

                                        <Table.Cell verticalAlign="middle">
                                            {el.title}
                                        </Table.Cell>
                                        <Table.Cell textAlign="center" verticalAlign="middle" colSpan="2">
                                            {this.state.setBasic === index ?
                                                <div>
                                                    <Form>
                                                        <Form.Dropdown
                                                            clearable
                                                            placeholder="Odaberite osnovni studijski program"
                                                            value={this.state.sPBasic}
                                                            onChange={this.handleInputChange}
                                                            name="sPBasic"
                                                            options={this.state.sPBasics}
                                                            search
                                                            fluid
                                                            selection
                                                        />
                                                        <Button color="blue" onClick={() => this.setSPBasic(el.studyProgram.id, el.studyProgram.optLock)}>Poveži</Button>
                                                        <Button color="red" basic="true" onClick={() => this.setState({ setBasic: false })}>Odustani</Button>

                                                    </Form>
                                                </div>
                                                : <div>
                                                    <Link to={{ pathname: '/povezivanje-implementacija-smjera/detalji', state: { implementation: el.studyProgram } }}>
                                                        <Button
                                                            basic="true"
                                                            color="blue"
                                                        >  Detalji
                                                        </Button>
                                                    </Link>
                                                    <Button
                                                        basic="true"
                                                        color="teal"
                                                        onClick={() => this.setState({ setBasic: index })}
                                                    > Povezivanje
                                                    </Button>
                                                </div>}


                                        </Table.Cell>
                                    </Table.Row>))}
                                </Table.Body>
                            </Table>
                            : 'Nema implementacija koje nisu povezane sa osnovnim studijskim programom.'
                        }
                    </Segment>
                    }
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgram/SPImplemenationsWithoutSPBasic.js